export default __webpack_public_path__ + "static/pie-in-a-doughnut-b47f8a38bb9e6f960bb233285ab3d131.png";